var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 13.25C12.2758 12.2408 12.6641 11.25 12.6641 9.75C12.6641 6.75 9.76194 5.99536 7.66406 5.77744L7.66406 2.5C7.66406 1.5335 6.88056 0.75 5.91406 0.75V0.75C4.94756 0.75 4.16406 1.5335 4.16406 2.5L4.16406 7.75L2.93756 8.45086C1.79256 9.10514 1.58313 10.6691 2.51562 11.6016L4.16406 13.25",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyButtonIcon);
export default __webpack_public_path__ + "static/media/apply-button-icon.2d6c26df27b0cd60adefe26c595a2e8b.svg";
export { ForwardRef as ReactComponent };